import { render, staticRenderFns } from "./FiPagination.vue?vue&type=template&id=64ff0d7f&scoped=true&lang=pug&"
import script from "./FiPagination.vue?vue&type=script&lang=js&"
export * from "./FiPagination.vue?vue&type=script&lang=js&"
import style0 from "./FiPagination.vue?vue&type=style&index=0&id=64ff0d7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff0d7f",
  null
  
)

export default component.exports